import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import ProductServices from "../../../services/ProductServices";
import MasterListEdit from "./MasterListEdit";
import Pagination from "../Pagenation/Pagenation";
import Loader from "../Loader/loader";

const MasterList = () => {
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState(230); // Number of items per page
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  //   const domData = Array.from(
  //     document.querySelectorAll("#transactions-data tbody tr")
  //   );
  //   domData.forEach((row, index) => {
  //     if (index >= first && index < second) {
  //       row.classList.remove("d-none");
  //     } else {
  //       row.classList.add("d-none");
  //     }
  //   });
  // };
  //api 

  useEffect(() => {
    setLoading(true); // Start loader
    ProductServices.getAllProduct()
      .then((response) => {
        setData(response?.data?.data || []);
        setLoading(false); // Stop loader once data is set
      })
      .catch((error) => {
        setError("There is some problem in fetching data!");
        setLoading(false); // Stop loader on error
      });
  }, [test]);

  const handleEditClick = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };

  useEffect(() => {
    if (searchTerm) {
      const filtered = data.filter(
        (item) =>
          String(item?.partNo)
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.category?.name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchTerm, data]);



  // Pagination setup
  useEffect(() => {
    setActivePage(0);
  }, [filteredData, sort]);

  const totalPages = Math.ceil(filteredData.length / sort);

  const handlePageChange = (page) => {
    setActivePage(page);
  };


  const handleSelectChange = (selectedOption) => {
    setSort(selectedOption.value);
    setActivePage(0);
  };

  return (
    <>
      <MasterListEdit
        item={selectedItem}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => setGridInsideModal(false)}
      />
      <div className="row">
        {loading ? (
          <Loader />
        ) : (
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6">
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="searchInput"
                          placeholder="Search by Part No., Category, or Description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-3 col-xxl-6">
                        <Select
                          placeholder="Select rows to display in User Table"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>Master List<span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="scrolltable">
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead
                              className="sticky-table-header"
                            >
                              <tr>
                                <th>S.No</th>
                                <th>Part No.</th>
                                <th>Image</th>
                                <th>Category</th>
                                <th>Sub Category</th>
                                <th>Unit</th>
                                <th>Description</th>
                                <th>Rate</th>
                                <th>Remark</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                                filteredData
                                  .slice(
                                    activePage * sort,
                                    (activePage + 1) * sort
                                  )
                                  .map((item, index) => (
                                    <tr key={index}>
                                      <td>{activePage * sort + index + 1}</td>
                                      <td>{item?.partNo}</td>
                                      <td>
                                        {item.image ? (
                                          <img
                                            src={`https://indigoinfra.in/img/product/${item?.image}`}
                                            alt={item.partNo}
                                            className="thumbnail-image"
                                          />
                                        ) : (
                                          "No image available"
                                        )}
                                      </td>
                                      <td>{item?.category?.name}</td>
                                      <td>{item?.subCategory?.name || 'NA'}</td>
                                      <td>{item?.unit?.name}</td>
                                      <td className="scrollable-description">{item?.description}</td> {/* Add the class here */}
                                      <td>{item?.rate || 0}</td>
                                      <td className="scrollable-description">{item?.remark}</td>
                                      <td className="text-center">
                                        <button
                                          className="btn btn-primary btn-xs sharp"
                                          onClick={() => handleEditClick(item)} // Open modal on edit click
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">No records found.</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">

                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredData.length > 0
                              ? activePage * sort + 1
                              : 0}{" "}
                            to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePage + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>

                          {totalPages > 0 && (
                            <Pagination
                              activePage={activePage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>

    </>
  );
};

export default MasterList;
